export default __webpack_public_path__ + "static/media/house-4.ca344d14.jpg";